import { CourtType } from 'app/Models/Enums/domstolType';

export interface BannerInfo {
    bannerName: string;
    bannerType: number;
    domstolType?: CourtType;
    mainPageLink?: string;
}

export const emptyBannerInfo: BannerInfo = {
    bannerName: '',
    bannerType: 0,
    domstolType: undefined,
    mainPageLink: undefined,
};
